import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {KeyphraseInIntroductionScore} from "./KeyphraseInIntroductionChecker";
import {Modal} from "peggirkit";
import {boolToYesNo} from "../../../../../../messages/en-US";
import ScoreIndicator from "../../../../elements/scoreIndicator/ScoreIndicator";
import {globalModalStyling} from "../../../../elements/modal/modalStyle";

type Props = {
    result?: KeyphraseInIntroductionScore
};

const KeyphraseInIntroductionScoreIndicator = ({result}: Props) => {
    const intl = useIntl();
    const [showExplanation, setShowExplanation] = useState(false);

    if (!result) {
        return <>-</>;
    }

    return (
        <>
            <ScoreIndicator
                score={result.score}
                onClick={() => setShowExplanation(true)}
            />

            <Modal
                {...globalModalStyling(intl)}
                show={showExplanation}
                onClose={() => setShowExplanation(false)}
                title={intl.formatMessage({id: "keyphraseInIntroduction"})}
            >
                <div className={"flex flex-col gap-6"}>
                    <p>
                        <FormattedMessage id="keyphraseInIntroduction.description-1"/>
                    </p>
                    <p>
                        <FormattedMessage id="keyphraseInIntroduction.description-2"/>
                    </p>
                    <p>
                        <FormattedMessage id="keyphraseInIntroduction.description-3"/>
                    </p>
                    <p>
                        <span className={"text-black dark:text-white font-medium"}>
                            <FormattedMessage
                                id="keyphraseInIntroduction.description-4"
                                values={{
                                    focusKeyphrasePresent: intl.formatMessage({id: boolToYesNo(result.focusKeyphrasePresent)}),
                                    focusKeyphraseInFirstSentence: intl.formatMessage({id: boolToYesNo(result.focusKeyphraseInFirstSentence)}),
                                    synonymPresent: intl.formatMessage({id: boolToYesNo(result.synonymPresent)}),
                                }}
                            />
                        </span>
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default KeyphraseInIntroductionScoreIndicator;